import React, { useState } from 'react';
import { GoogleMap, Marker, Circle, InfoWindow, useJsApiLoader } from '@react-google-maps/api';

// Helper to calculate distance between two lat/lng points in miles
function haversineDistance(lat1, lon1, lat2, lon2) {
  function toRad(x) {
    return x * Math.PI / 180;
  }
  const R = 3958.8; // Radius of Earth in miles
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

const containerStyle = {
  width: '100%',
  height: '300px', // Increased height for a bigger map
};

const ClubRadiusMap = ({ homeClub, radiusMiles, clubs }) => {
  const [selectedClubId, setSelectedClubId] = useState(null);
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey || '',
  });
  if (!isLoaded || !homeClub || !homeClub.lat || !homeClub.lng) return null;
  const center = { lat: homeClub.lat, lng: homeClub.lng };
  // Dynamic zoom calculation
  const mapWidthPx = 400; // Adjust if your map width changes
  const radiusMeters = radiusMiles * 1609.34;
  // Prevent log2(0) or negative zoom
  const dynamicZoom = radiusMiles > 0
    ? Math.min(15, Math.max(2, Math.log2(156543.03392 * Math.cos(center.lat * Math.PI / 180) * mapWidthPx / (radiusMeters * 2))))
    : 11;

  return (
    <GoogleMap
      key={`${homeClub.id}-${radiusMiles}`}
      mapContainerStyle={containerStyle}
      center={center}
      zoom={dynamicZoom}
      options={{
        disableDefaultUI: true,
        draggable: false,
        scrollwheel: false,
        keyboardShortcuts: false,
      }}
    >
      <Circle
        center={center}
        radius={radiusMiles * 1609.34}
        options={{ strokeColor: '#4285F4', fillColor: '#4285F4', fillOpacity: 0.1 }}
      />
      <Marker position={center} label="🏠" />
      {clubs.map(club => {
        if (!club.lat || !club.lng) return null;
        const inRadius = haversineDistance(homeClub.lat, homeClub.lng, club.lat, club.lng) <= radiusMiles;
        return (
          <Marker
            key={club.id}
            position={{ lat: club.lat, lng: club.lng }}
            icon={{
              url: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f3be.png',
              scaledSize: { width: 20, height: 20 },
            }}
            opacity={inRadius ? 1.0 : 0.3}
            onClick={() => setSelectedClubId(club.id)}
          >
            {selectedClubId === club.id && (
              <InfoWindow onCloseClick={() => setSelectedClubId(null)}>
                <div>{club.ClubName}</div>
              </InfoWindow>
            )}
          </Marker>
        );
      })}
    </GoogleMap>
  );
};

export default ClubRadiusMap;
